<template>
    <modal
        id="custom-employee-export-modal"
        v-model="showModal"
        :title="$t('custom_employee_export')"
        @submit="exportEmployees"
        :loading="loading"
        :btn-label="$t('export')"
        :preloader="false">

        <form ref="form" @submit.prevent="exportEmployees">
            <div class="form-group">
                <label>{{ $t('select_fields_to_export') }}</label>
                <app-input
                    type="multi-select"
                    v-model="selectedFields"
                    :list="availableFields"
                    :error-message="errorMessage"
                    list-value-field="value"
                />
            </div>

            <div class="alert alert-info mt-3">
                <i class="fas fa-info-circle"></i>
                {{ $t('select_employee_export_fields_note') }}
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "CustomEmployeeExportModal",
    mixins: [ModalMixin],
    data() {
        return {
            loading: false,
            errorMessage: '',
            selectedFields: [],
        }
    },
    computed: {
        availableFields() {
            return [
                {id: 'employee_id', value: this.$t('employee_id')},
                {id: 'badge_card_number', value: this.$t('badge_card_number')},
                {id: 'email', value: this.$t('email')},
                {id: 'first_name', value: this.$t('first_name')},
                {id: 'last_name', value: this.$t('last_name')},
                {id: 'phone_number', value: this.$t('phone_number')},
                {id: 'gender', value: this.$t('gender')},
                {id: 'date_of_birth', value: this.$t('birthday')},
                {id: 'joining_date', value: this.$t('joining_date')},
                {id: 'marital_status', value: this.$t('marital_status')},
                {id: 'fathers_name', value: this.$t('fathers_name')},
                {id: 'mothers_name', value: this.$t('mothers_name')},
                {id: 'social_security_number', value: this.$t('social_security_number')},
                {id: 'address', value: this.$t('address')},
                {id: 'salary', value: this.$t('salary')},
                {id: 'department_name', value: this.$t('department')},
                {id: 'is_department_manager', value: this.$t('is_department_manager')},
                {id: 'parent_department', value: this.$t('parent_department')},
                {id: 'designation', value: this.$t('designation')},
                {id: 'work_shift', value: this.$t('work_shift')},
                {id: 'employment_status', value: this.$t('employment_status')},
                {id: 'bank_name', value: this.$t('bank_name')},
                {id: 'bank_account_number', value: this.$t('account_number')},
                {id: 'bank_branch', value: this.$t('bank_branch')},
                {id: 'emergency_contact_name', value: this.$t('emergency_contact_name')},
                {id: 'emergency_contact_phone', value: this.$t('emergency_contact_phone')},
                {id: 'emergency_contact_relationship', value: this.$t('emergency_contact_relationship')},
                {id: 'user_status', value: this.$t('status')},
                {id: 'created_at', value: this.$t('created_at')},
            ];
        }
    },
    methods: {
        exportEmployees() {
            if (!this.selectedFields || this.selectedFields.length === 0) {
                this.errorMessage = this.$t('please_select_at_least_one_field');
                return;
            }

            this.loading = true;
            this.errorMessage = '';

            axiosPost('/app/export/custom-employee', {
                fields: this.selectedFields
            }, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `employees_custom_${new Date().toISOString().slice(0,10)}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                this.$toastr.s('', this.$t('file_downloaded_successfully'));
                this.closeModal();
            }).catch(error => {
                if (error.response && error.response.data) {
                    this.$toastr.e('', this.$t('export_failed'));
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        closeModal() {
            this.selectedFields = [];
            this.errorMessage = '';
            $('#custom-employee-export-modal').modal('hide');
            this.$emit('input', false);
        }
    }
}
</script>
